module.exports = __webpack_public_path__ + "static/media/rom7.d1316017.jpg";